import Options from './Options'
import Select from './Select'

Select.Options = Options

export default Select



// WEBPACK FOOTER //
// ./src/components/Select/index.js